__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "onboarding";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.12.9", () => (Promise.all([__webpack_require__.e(436), __webpack_require__.e(610), __webpack_require__.e(533), __webpack_require__.e(212)]).then(() => (() => (__webpack_require__(99610))))));
			register("antd", "5.23.3", () => (Promise.all([__webpack_require__.e(482), __webpack_require__.e(928), __webpack_require__.e(533), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(97482))))));
			register("apollo-upload-client", "17.0.0", () => (Promise.all([__webpack_require__.e(436), __webpack_require__.e(212), __webpack_require__.e(447)]).then(() => (() => (__webpack_require__(19447))))));
			register("axios", "1.7.9", () => (__webpack_require__.e(914).then(() => (() => (__webpack_require__(31914))))));
			register("graphql", "16.10.0", () => (__webpack_require__.e(926).then(() => (() => (__webpack_require__(37926))))));
			register("js-cookie", "3.0.5", () => (__webpack_require__.e(468).then(() => (() => (__webpack_require__(35468))))));
			register("jwt-decode", "4.0.0", () => (__webpack_require__.e(512).then(() => (() => (__webpack_require__(68512))))));
			register("lucide-react", "0.474.0", () => (Promise.all([__webpack_require__.e(157), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(89157))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(154), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(68154))))));
			register("react-router-dom", "6.29.0", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(533), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(92648))))));
			register("react-syntax-highlighter", "15.5.0", () => (Promise.all([__webpack_require__.e(200), __webpack_require__.e(533), __webpack_require__.e(23)]).then(() => (() => (__webpack_require__(78200))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("recharts", "2.15.1", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(23655))))));
			register("ts-utils-lib", "0.0.8", () => (Promise.all([__webpack_require__.e(236), __webpack_require__.e(533)]).then(() => (() => (__webpack_require__(67236))))));
			register("zustand", "4.5.6", () => (Promise.all([__webpack_require__.e(533), __webpack_require__.e(85)]).then(() => (() => (__webpack_require__(34085))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};